import React from 'react';
import { IconProps } from './type';

export const CrossIcon = ({ color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.10541 9.1059C9.3983 8.81301 9.87318 8.81301 10.1661 9.1059L15.9997 14.9395L21.8333 9.1059C22.1262 8.81301 22.6011 8.81301 22.894 9.1059C23.1869 9.39879 23.1869 9.87367 22.894 10.1666L17.0604 16.0002L22.894 21.8338C23.1869 22.1267 23.1869 22.6016 22.894 22.8945C22.6011 23.1874 22.1262 23.1874 21.8333 22.8945L15.9997 17.0609L10.1661 22.8945C9.87318 23.1874 9.3983 23.1874 9.10541 22.8945C8.81252 22.6016 8.81252 22.1267 9.10541 21.8338L14.939 16.0002L9.10541 10.1666C8.81252 9.87367 8.81252 9.39879 9.10541 9.1059Z"
        fill={color}
      />
    </svg>
  );
};
